"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextNode = void 0;
/**
 * Determine if a nodeType is a text node
 *
 * @param nodeTyp Node.nodeType
 * @returns boolean
 */
const isTextNode = (nodeType) => {
    return nodeType === Node.TEXT_NODE;
};
exports.isTextNode = isTextNode;
//# sourceMappingURL=index.js.map